import { openAppSettings as openSharedSettings, settingsWindowUrl } from "@suite/settings";

/** The window event the in-app settings dialog listens for (the default path). */
export const OPEN_SETTINGS_EVENT = "sak:open-settings";

/**
 * The settings-window plan: every sak settings entry point — the suite bar's
 * gear button (`chrome:settings`) — opens the in-app settings dialog by
 * DEFAULT; when the user opts into the separate window (the toggle in the
 * settings panel), it raises the shared two-column settings window instead.
 * The in-app half travels through the OPEN_SETTINGS_EVENT so the dialog's
 * host raises it directly (never back through this dispatcher — that would
 * loop).
 */
export function openSettings(tab?: string): void {
  openSharedSettings({
    request: { app: "sak", url: settingsWindowUrl(tab) },
    openInApp: () =>
      window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT, { detail: { tab } })),
  });
}
